import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationSandbox } from '@hohr/config';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent {
  @Input() authenticated = false;
  @Input() username: string;
  @Input() myprofileURI: string;
  @Input() translations: Record<string, string>;

  constructor(
    private popover: PopoverController,
    public authSandbox: AuthenticationSandbox,
    public router: Router
  ) {}

  close() {
    this.popover.dismiss();
  }
}
